let id = 0;
export function getNextId() {
  id += 1;
  return id;
}
export function resetId() {
  id = 0;
  return id;
}